import {$auth} from "@/plugins/auth"

type AccountLike = {
  id?: unknown
  trial_ended?: unknown
  trial_ends_at?: unknown
} | null | undefined

/**
 * Remembers that someone has seen the "Plus access has ended" notice.
 *
 * localStorage, so it is per device. Move it server side if it ever has to be
 * once per person. The key carries trial_ends_at so a later lapse gets its own
 * notice rather than being swallowed by the first.
 */
function storageKey(account: AccountLike): string | null {
  if (!account?.id) return null

  return `idly.plus_ended_ack.${account.id}.${account.trial_ends_at ?? ''}`
}

function currentAccount(): AccountLike {
  return $auth.user?.account as AccountLike
}

/** Should the notice be shown right now? */
export function plusEndedPending(): boolean {
  const account = currentAccount()

  if (account?.trial_ended !== true) return false

  const key = storageKey(account)
  if (!key) return false

  try {
    return window.localStorage.getItem(key) === null
  } catch {
    // Private browsing and locked-down settings both throw here. Showing the
    // notice again beats crashing the guard that decides whether they get in.
    return true
  }
}

export function acknowledgePlusEnded(): void {
  const key = storageKey(currentAccount())
  if (!key) return

  try {
    window.localStorage.setItem(key, '1')
  } catch {
    // Nothing to do. They see it again next time, which is survivable.
  }
}
